import React from 'react'
import { useState } from 'react';
import { createContext } from 'react';

export const SpotContext = createContext();

export const SpotProvider = ({ children }) => {

  // SPOT GPT code start

  const [companyjdlist, setCompanyjdlist] = useState([]);
  const [selectedjdid, setSelectedjdid] = useState("")
  const [selectedjdname, setSelectedjdname] = useState("")
  const [jdId, setJdId] = useState("")
  const [candidates_referring_to, setCandidates_referring_to] = useState([])
  const [selectedcandidates_referring_to, setSelectedcandidates_referring_to] = useState([])
  const [gptActivatedFor, setGptActivatedFor]=useState({})

  // SPOT Process Code start
  const [spotprocessCompanyJDList, setSpotprocessCompanyJDList] = useState([])
  const [spotprocessSelectedJDID, setSpotprocessSelectedJDID] = useState("")
  const [spotprocessSelectedJD, setSpotprocessSelectedJD] = useState({})
  const [spotprocessSelectedJDName, setSpotprocessSelectedJDName] = useState("")
  const [spotprocessSelectedResume, setSpotprocessSelectedResume] = useState({})
  // Shorlisted from API 
  const [spotprocessAiJDSlcandidates, setSpotprocessAiJDSlcandidates] = useState([])      // sl = ShortListed
  const [spotprocessAiResumeSlCandidates, setSpotprocessAiResumeSlCandidates] = useState([])      // sl = ShortListed
  // outrich selected candidate 
  const [spotprocessAiJDSselectedCandidates, setSpotprocessAiJDSselectedCandidates] = useState([])
  const [spotprocessAiResumeselectedCandidates, setSpotprocessAiResumeselectedCandidates] = useState([])
  // prepare AI and Resume loading animation code 
  const [loadingPrepareAIData, setLoadingPrepareAIData] = useState(false); // Loading state for job data
  const [loadingPrepareAIResumeData, setLoadingPrepareAIResumeData] = useState(false); // Loading state for resume    

  // SPOT Process Code end

  // spot outreach code start
  const [finalSelectedCandidate,setFinalSelectedCandidate]=useState([])
  // spot outreach code end

  // multiple 5,10,20 selection ourDataBase code start
  const selectTopCandidatesFromOurDataBase = (number) => {
    const topCandidates = spotprocessAiJDSlcandidates.slice(0, number);
    const topCandidateIds = topCandidates.map((candidate) => candidate);
    setSpotprocessAiJDSselectedCandidates(topCandidateIds);
  };
  // multiple 5,10,20 selection ourDataBase code end

  // multiple 5,10,20 selection Resume code start
  const selectTopCandidatesFromResume = (number) => {
    const topCandidates = spotprocessAiResumeSlCandidates.slice(0, number);
    const topCandidateIds = topCandidates.map((candidate) => candidate);
    setSpotprocessAiResumeselectedCandidates(topCandidateIds);
  };
  // multiple 5,10,20 selection Resume code end


  return (
    <SpotContext.Provider value={{
      gptActivatedFor, 
      setGptActivatedFor,
      companyjdlist,
      setCompanyjdlist,
      setSelectedjdid,
      selectedjdid,
      selectedjdname,
      setSelectedjdname,
      setCandidates_referring_to,
      candidates_referring_to,
      setSpotprocessCompanyJDList,
      spotprocessCompanyJDList,
      setSpotprocessSelectedJDID,
      setSpotprocessSelectedJD,
      spotprocessSelectedJD,
      setSpotprocessAiJDSlcandidates,
      spotprocessAiJDSlcandidates,
      setSpotprocessAiResumeSlCandidates,
      spotprocessAiResumeSlCandidates,
      setSpotprocessAiJDSselectedCandidates,
      spotprocessAiJDSselectedCandidates,
      setSpotprocessAiResumeselectedCandidates,
      spotprocessAiResumeselectedCandidates,
      setLoadingPrepareAIData,
      loadingPrepareAIData,
      setLoadingPrepareAIResumeData,
      loadingPrepareAIResumeData,
      setSpotprocessSelectedResume,
      spotprocessSelectedResume,
      setFinalSelectedCandidate,
      finalSelectedCandidate,
      setSelectedcandidates_referring_to,
      selectedcandidates_referring_to,
      selectTopCandidatesFromOurDataBase,
      selectTopCandidatesFromResume

    }}>
      {children}
    </SpotContext.Provider>
  )
}

// export default SpotContext
